import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Menu, MenuItem } from '@mui/material'
import Fade from '@mui/material/Fade'
import config from '../../../config'
import GB from '@assets/images/icons/gb.svg'
import RU from '@assets/images/icons/ru.svg'
import ES from '@assets/images/icons/es.svg'
import {
	PRIVACY_POLICY,
	COOKIE_POLICY,
	RISK_DISCLOSURE,
	TERMS_CONDITIONS,
} from '../../../constants'
import './layout.sass'
import {
	ABOUT_US_PAGE,
	AFFILIATE_PROGRAM_PAGE,
	FAQ_PAGE,
	MAIN_PAGE,
	PWA_PAGE,
	PWA_MACOSPAGE,
	SUPPORT_PAGE,
	TOOLS_PAGE,
} from '../../../constants'

export const Layout = ({ children }) => {
	const [anchorEl, setAnchorEl] = useState(false)
	const open = Boolean(anchorEl)
	const { pathname } = useLocation()

	const handleClose = () => {
		setAnchorEl(null)
	}

	const handleChange = () => {
		setAnchorEl(null)
	}

	// const handleClick = event => {
	// 	setAnchorEl(event.currentTarget)
	// }

	const getLocaleIcon = locale => {
		if (locale === 'en') {
			return GB
		} else if (locale === 'ru') {
			return RU
		}
	}

	const langNames = {
		en: 'English',
		ru: 'Русский',
	}

	useEffect(() => {
		const loadScript = src => {
			return new Promise((resolve, reject) => {
				if (document.querySelector(`script[src="${src}"]`)) {
					resolve()
					return
				}

				const script = document.createElement('script')
				script.src = src
				script.async = true
				script.onload = resolve
				script.onerror = reject
				script.setAttribute('temporary', '')
				document.body.appendChild(script)
			})
		}

		const loadJQueryScripts = async () => {
			try {
				await loadScript('/jq/jquery-3.1.1.min.js')
				await loadScript('/jq/jquery.plugins.min.js')
				await loadScript('/jq/jquery.main.js')
			} catch (e) {
				console.error('Error jQuery script:', e)
			}
		}

		loadJQueryScripts()

		return () => {
			const temporaryScripts = document.querySelectorAll('[temporary]')
			if (temporaryScripts?.length) {
				console.log(temporaryScripts)
				temporaryScripts.forEach(script => {
					script.remove()
				})
			}
		}
	}, [pathname])
	const trackEvent = (eventName, params = {}) => {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: eventName,
			...params,
		});
	};
	const hostname = window.location.hostname; 
	const parts = hostname.split('.');
	
	let baseDomain = '';
	
	if (parts.length === 2) {
	  baseDomain = hostname; 
	} else if (parts.length > 2) {
	  baseDomain = parts.slice(-2).join('.'); 
	}
	
	const signupUrl = `https://app.${baseDomain}/auth/signup`; 
	const loginpUrl = `https://app.${baseDomain}/auth/login`; 
	const tryDemoUrl = `https://app.${baseDomain}/try-demo`; 

	return (
		<div className='basic-wrapper' id='wrapper'>
			<header className='basic-header'>
				<input id='check-menu' type='checkbox' />
				<label className='toggle-menu' htmlFor='check-menu'></label>
				<Link className='basic-logo' to='/'>
					<img
						src={require('@assets/images/main/basic-logo.svg').default}
						alt='logo'
					/>
				</Link>
				<nav className='basic-nav'>
					<ul className='main-menu'>
						<li>
							<Link to={MAIN_PAGE}>Home</Link>
						</li>
						<li>
							<Link to={PWA_PAGE}>PWA</Link>
						</li>
						<li>
							<Link to={FAQ_PAGE}>FAQ</Link>
						</li>
						<li>
							<Link to={SUPPORT_PAGE}>Support</Link>
						</li>
						<li>
							<Link to={AFFILIATE_PROGRAM_PAGE}>Affiliate Program</Link>
						</li>
						<li>
							<Link to={TOOLS_PAGE}>Tools</Link>
						</li>
						<li>
							<Link to={ABOUT_US_PAGE}>About Us</Link>
						</li>
					</ul>
					<div className='header-actions'>
						<button className='lang'>
							Language
							<img src={getLocaleIcon('en')} alt='lang' />
							<small>{langNames['en']}</small>
						</button>
						<Menu
							anchorEl={anchorEl}
							open={open}
							onClose={handleClose}
							TransitionComponent={Fade}
							transformOrigin={{
								vertical: 'top',
								horizontal: 'right',
							}}
							className='mini-select'
						>
							{config.supported_locales.includes('en') && (
								<MenuItem data-my-value='en' onClick={handleChange}>
									<div className='header__change-btn'>
										<img src={GB} alt='lang' />
										<p className='header__change-btn-text'>English</p>
									</div>
								</MenuItem>
							)}
							{config.supported_locales.includes('ru') && (
								<MenuItem data-my-value='ru' onClick={handleChange}>
									<div className='header__change-btn'>
										<img src={RU} alt='lang' />
										<p className='header__change-btn-text'>Русский</p>
									</div>
								</MenuItem>
							)}
							{config.supported_locales.includes('es') && (
								<MenuItem data-my-value='es' onClick={handleChange}>
									<div className='header__change-btn'>
										<img src={ES} alt='lang' />
										<p className='header__change-btn-text'>Español</p>
									</div>
								</MenuItem>
							)}
						</Menu>
						{/* <Link className='basic-button transparent-button' to={AUTH_PAGE}>
							{' '}
							Sign in
						</Link> */}
						<a
							className='basic-button'
							href={loginpUrl}
						>
							Login
						</a>
						{/* <Link className='basic-button' to={TRY_DEMO}>
							Try for free
						</Link>
						<Link className='login-button' to={AUTH_PAGE}>
							Login
						</Link> */}
							<a
							className="basic-button"
							href="#"
							onClick={(e) => {
								e.preventDefault(); 
								trackEvent('try_demo_click', {
								event_category: 'Navigation',
								event_label: 'Try for free button',
								});
								setTimeout(() => {
								window.location.href = tryDemoUrl;
								}, 300); 
							}}
							>
							Try for free
							</a>
					</div>
					{/* <Link to={AUTH_SIGN_UP} className='basic-button'>
						Get Started for $0
					</Link> */}
					<a
						className='basic-button'
						href={signupUrl}
					>
						Get Started for $0
					</a>
					<div className='currency-section'>
						<dl className='bitcoin'>
							<dt>Bitcoin</dt>
							<dd>87,523</dd>
						</dl>
						<div className='currency-row'>
							<ul>
								<li>UPI 9%</li>
								<li>IMPS 9%</li>
								<li>JazzCash 8%</li>
								<li>NEFT 9%</li>
								<li>RTGS 9%</li>
								<li>EasyPaisa 8%</li>
							</ul>
						</div>
					</div>
				</nav>
				{/* <Link to={AUTH_PAGE} className='login-btn' href='#'></Link> */}
				<a className='login-btn' href={loginpUrl}></a>
			</header>
			{children}
			<a className='scroll-btn' href='#wrapper'></a>
			<footer className='basic-footer'>
				<div className='container'>
					<div className='footer-box'>
						<div className='footer-social-media'>
							<h4>
								Follow us on <br />
								social media
							</h4>
							<div className='social-media'>
								<a
									href='https://www.instagram.com/cronikaofficial?igsh=MW5odWk1bTYxd2s2cQ%3D%3D&amp;utm_source=qr'
									
									target='_blank'
								>
									<img
										src={
											require('@assets/images/main/instagram-icon.svg').default
										}
										alt='icon'
									/>
								</a>
								<a
									href='https://t.me/CronikaLiveBot'
									target='_blank'
									
								>
									<img
										src={
											require('@assets/images/main/telegram-icon.svg').default
										}
										alt='icon'
									/>
								</a>
								<a
									href='https://www.youtube.com/@cronikamain'
									
									target='_blank'
								>
									<img
										src={
											require('@assets/images/main/youtube-icon.svg').default
										}
										alt='icon'
									/>
								</a>
								<a
									href='https://www.tiktok.com/@cronikamain?_t=ZN-8vzdRUzWm8M&_r=1'
									
									target='_blank'
								>
									<img
										src={
											require('@assets/images/main/tiktok-icon-white.svg')
												.default
										}
										alt='icon'
									/>
								</a>
								<a
									href='https://x.com/cronikaofficial?s=21'
									target='_blank'
									
								>
									<img
										src={
											require('@assets/images/main/x-icon-white.svg').default
										}
										alt='icon'
									/>
								</a>
							</div>
						</div>
						<div className='footer-main'>
							<div className='footer-menu'>
								<div className='box'>
									<span className='title-menu'>Download App</span>
									<ul>
										<li>
											<Link to={PWA_PAGE}>PWA</Link>
										</li>
										<li>
											<a
												target='_blank'
												href='https://t.me/CronikaLiveBot'
												
											>
												TG Mini App
											</a>
										</li>
										<li>
											<a
												href='/setups/Cronika-Setup-1.0.0-x64.exe'
												download

											>
												Windows x64
											</a>
										</li>
										<li>
											<a
												href='/setups/Cronika-Setup-1.0.0-x32.exe'
												download

											>
												Windows x32
											</a>
										</li>
										{/* <li>
											<Link
												to={PWA_MACOSPAGE}

											>
												<figure className='desktop-icon'></figure>
												Mac Intel
											</Link>
										</li> */}
										<li>
											<Link
												to={PWA_MACOSPAGE}
											>
												<figure className='desktop-icon'></figure>
												Mac PWA
											</Link>
										</li>
									</ul>
								</div>
								<div className='box'>
									<span className='title-menu'>Help</span>
									<ul>
										<li>
											<Link to={MAIN_PAGE}>Home</Link>
										</li>
										<li>
											<Link to={FAQ_PAGE}>FAQ</Link>
										</li>
										<li>
											<Link to={SUPPORT_PAGE}>Support</Link>
										</li>
										<li>
											<Link to={AFFILIATE_PROGRAM_PAGE}>Affiliate Program</Link>
										</li>
										<li>
											<Link to={TOOLS_PAGE}>Tools</Link>
										</li>
										<li>
											<Link to={ABOUT_US_PAGE}>About Us</Link>
										</li>
									</ul>
								</div>
								<div className='footer-scan'>
									<figure className='scan'>
										<img
											src={require('@assets/images/main/new_qr.png')}
											alt='img'
										/>
									</figure>
									<div className='scan-text'>
										<h4>
											Financial future <br />
											in your hands
										</h4>
										<Link className='more-link' to={PWA_PAGE} target='_blank'>
											Download App now
										</Link>
									</div>
								</div>
							</div>
							<span className='copyright'>
								© {new Date().getFullYear()} Cronika
							</span>
							<p>
								The transactions available on the Cronika platform are intended
								exclusively for fully competent adults. Trading in financial
								instruments involves significant risk and may not be suitable
								for all users. Engaging in such transactions can lead to
								substantial losses, including the total loss of funds held in
								your account. Before initiating any trading activity on Cronika,
								you should carefully review the Terms of Service and the Privacy
								Policy. It is your responsibility to fully understand the risks
								associated with trading financial or digital instruments. By
								using the platform, you acknowledge that you are acting at your
								own risk and discretion.
							</p>
							<ul className='bottom-menu'>
								<li>
									<Link to={PRIVACY_POLICY}>Privacy policy</Link>
								</li>
								<li>
									<Link to={TERMS_CONDITIONS}>Terms & Conditions</Link>
								</li>
								<li>
									<Link to={RISK_DISCLOSURE}>Risk Disclosure</Link>
								</li>
								<li>
									<Link to={COOKIE_POLICY}>Cookie Policy</Link>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</footer>
		</div>
	)
}
